import { useEffect, useState } from 'react';
import { Box, CircularProgress, Grid } from '@mui/material';
import useTitle from '../../hooks/UseTitle';
import api from '../../services/api';

function Home() {
  const [htmlData, setHtmlData] = useState({ __html: '<div class="bg-white text-center">お知らせ情報はございません。</div>' });
  const [isLoading, setIsLoading] = useState(false);

  useTitle('ビルドセルフ');

  useEffect(() => {
    setIsLoading(true);
    const awaitApi = async () => {
      await api.get('v1/home')
        .then((res) => {
          const { data } = res.data;
          if (data) {
            setHtmlData({ __html: res.data.data });
          }
        });
    };

    awaitApi().finally(() => {
      setIsLoading(false);
    });
  }, []);

  return (
    <main className="content">
      <div className="container-fluid py-5">
        <Grid>
          <Grid item className="text-center">
            <h2 className="mb-3 fw-bold">お知らせ</h2>
          </Grid>
          <Grid item>
            <Box className="card shadow-sm">
              <Box
                sx={{
                  overflowY: 'auto',
                  maxHeight: 'calc(100vh - 248px)',
                }}
                className="card-body"
              >
                <Box className="container-fluid">
                  {isLoading ? (
                    <CircularProgress
                      size={15}
                      sx={{
                        display: 'block',
                        margin: '0 auto',
                      }}
                    />
                  ) : (
                    <div dangerouslySetInnerHTML={htmlData} />
                  )}
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </div>
    </main>
  );
}

export default Home;
